import React, { forwardRef } from 'react'

import { IconProps } from './types'

const Copy = forwardRef<SVGSVGElement, IconProps>(
  ({ color, size, ...props }, ref) => (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.5 4V2.5H2.5V10.5H4M5.5 5.5H13.5V13.5H5.5V5.5Z"
        stroke={color}
      />
    </svg>
  ),
)

Copy.displayName = 'Copy'

Copy.defaultProps = {
  size: 16,
  color: 'currentColor',
}

export default Copy
